import * as React from 'react';
import { useEffect } from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Iconify from '../iconify';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import Stack from '@mui/material/Stack';
import SteLib from 'src/lib/stelib';
import dayjs from 'dayjs';
import 'dayjs/locale/it';


export default function EditMoviePopup({setOpenEdit, openEdit, setEditData, editData, successCallback}) {
  const [open, setOpen] = React.useState(false);

  const initData = {
    id: undefined,
    title: undefined,
    coverImg: "",
    duration: undefined,
    language: undefined,
    synopsis: undefined,
    genre: undefined,
    trailer: undefined,
    publishedAt: undefined
  }

  const [formData, setFormData] = React.useState(initData);

  const [formSubmitted, setFormSubmitted] = React.useState(false);

  useEffect(() => {
    if(openEdit === true)
    {
      handleEditOpen();
      if(editData !== undefined)
      {
        setCoverImg(editData.coverImg);
        setFormData(editData)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [openEdit])

  const handleEditOpen = () => {
    setOpenEdit(false);
    handleClickOpen();
    setOpen(true);
  };
  
  const handleClickOpen = () => {
    setFormData(initData);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setEditData(undefined);
    setFormSubmitted(false);
  };

  const handleSave = () => {
    setFormSubmitted(true);
    if(!fieldNotValid(formData.title, true) &&
       !fieldNotValid(formData.duration, true) &&
       !fieldNotValid(formData.language, true) &&
       !fieldNotValid(formData.genre, true) &&
       !fieldNotValid(formData.synopsis, true) &&
       !trailerNotValid(formData.trailer, true) &&
       !dateNotValid(formData.publishedAt)
    )
    {
      let d = new Date(Date.parse(formData.publishedAt));
      formData.publishedAt = d.getFullYear()+'-'+(d.getMonth() + 1)+'-'+d.getDate();

      //PUT
      if(editData !== undefined)
      {
        SteLib.PutRequest("movies/"+formData.id, formData, false).then((data) => {
          handleClose();
          successCallback();
        });
      }
      else //POST
      {
        SteLib.PostRequest("movies", formData, false).then((data) => {
          handleClose();
          successCallback();
        });
      }
    }
    else
    {
    }
  };

  let fieldNotValid = (field, ignoreFormSubmitted = false) => {
    let fSub = ignoreFormSubmitted ? true : formSubmitted;
    return (field === "" || field === undefined || field === null) && fSub;
  }

  let trailerNotValid = (field, ignoreFormSubmitted = false) => {
    let fSub = ignoreFormSubmitted ? true : formSubmitted;
    return (field !== "" && field !== undefined && field !== null && field.indexOf("https://") !== 0) && fSub;
  }

  let dateNotValid = (date) => {
    if (typeof date === 'string')
    {
      date = Date.parse(date);
    }
    return isNaN(date);
  }

  const [coverImg, setCoverImg] = React.useState(null);

  let handleUpload = (e) => {

    const reader = new FileReader();
    reader.onloadend = () => {
        // Use a regex to remove data url part
        const base64String = reader.result
            .replace('data:', '')
            .replace(/^.+,/, '');

        let b64 = base64String;
        setCoverImg(b64);
        setFormData({...formData, coverImg: b64});
    };
    reader.readAsDataURL(e.target.files[0]);
  }

  return (
    <div>
      <Button variant="contained" onClick={handleClickOpen} startIcon={<Iconify icon="eva:plus-fill" />}>
        Nuovo Film
      </Button>
      <Dialog fullWidth maxWidth="xs" open={open} onClose={handleClose}>
        <DialogTitle>{editData !== undefined && editData.id > 0 ? "Modifica Film" : "Nuovo Film"}</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Inserisci i dati del film
          </DialogContentText>
          <Stack spacing={3}>
              <Stack>
                <div style={{width: "100%", margin: "1rem 0"}}>
                <img alt="" src={`data:image/jpeg;base64,${coverImg}`} style={{margin: "auto", border: "1px solid gray", borderRadius:".75rem", width:"100px", height:"124px" }}></img>
                </div>
                <Button
                  variant="contained"
                  component="label"
                >
                  Scegli copertina
                  <input
                    onChange={handleUpload}
                    type="file"
                    hidden
                  />
                </Button>
              </Stack><br/>
              <TextField
                  autoFocus
                  margin="dense"
                  id="title"
                  label="Titolo"
                  type="text"
                  error={fieldNotValid(formData.title)}
                  value={formData.title}
                  onChange={(newValue) => {
                    setFormData({...formData, title: newValue.target.value})
                  }}
                  variant="standard"
              />
              <TextField
                  margin="dense"
                  id="duration"
                  label="Durata"
                  type="number"
                  error={fieldNotValid(formData.duration)}
                  value={formData.duration}
                  onChange={(newValue) => {
                    setFormData({...formData, duration: newValue.target.value})
                  }}
                  variant="standard"
              />
              <TextField
                  margin="dense"
                  id="language"
                  label="Lingua"
                  type="text"
                  error={fieldNotValid(formData.language)}
                  value={formData.language}
                  onChange={(newValue) => {
                    setFormData({...formData, language: newValue.target.value})
                  }}
                  variant="standard"
              />
              <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="it">
                <DatePicker
                  views={['day', 'month', 'year']}
                  label="Pubblicato il"
                  value={formData.publishedAt !== undefined ? dayjs(formData.publishedAt) : undefined}
                  onChange={(newValue) => {
                    setFormData({...formData, publishedAt: newValue})
                  }}
                  slotProps={{ textField: { variant: "standard", error: fieldNotValid(formData.publishedAt) || (dateNotValid(formData.publishedAt) && formSubmitted) } }}

                  renderInput={(params) => <TextField variant='standard' {...params} 
                  />}
                />
              </LocalizationProvider>
              <TextField
                  margin="dense"
                  id="genre"
                  label="Genere"
                  type="text"
                  error={fieldNotValid(formData.genre)}
                  value={formData.genre}
                  onChange={(newValue) => {
                    setFormData({...formData, genre: newValue.target.value})
                  }}
                  variant="standard"
              />
              <TextField
                  margin="dense"
                  id="synopsis"
                  label="Sinossi"
                  type="text"
                  multiline
                  error={fieldNotValid(formData.synopsis)}
                  value={formData.synopsis}
                  onChange={(newValue) => {
                    setFormData({...formData, synopsis: newValue.target.value})
                  }}
                  variant="standard"
              />
              <TextField
                  margin="dense"
                  id="trailer"
                  label="Trailer"
                  type="text"
                  multiline
                  helperText="Il campo trailer dev'essere vuoto o iniziare con 'https://'"
                  error={trailerNotValid(formData.trailer)}
                  value={formData.trailer}
                  onChange={(newValue) => {
                    setFormData({...formData, trailer: newValue.target.value})
                  }}
                  variant="standard"
              />
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Annulla</Button>
          <Button onClick={handleSave}>Salva</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}